module.exports = __webpack_public_path__ + "static/media/search-icon.c0845093.svg";